import {LeftOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';

type SectionHeaderProps = {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  actionLabel,
  onAction
}) => {
  return (
    <header className="flex items-start justify-between gap-3">
      <div className="flex min-w-0 flex-col gap-1">
        <h2 className="text-subtitle-md text-neutral-fg">{title}</h2>
        {description && <p className="text-body-sm text-gray-07">{description}</p>}
      </div>
      {actionLabel && onAction && (
        <Button
          variant="link"
          color="secondary"
          size="sm"
          className="shrink-0 px-0"
          onClick={onAction}
          endIcon={<LeftOutlined aria-hidden />}
        >
          {actionLabel}
        </Button>
      )}
    </header>
  );
};

export default SectionHeader;
